export enum CompetitionsView {
  MY_COMPETITIONS = 1,
  BROWSE = 2,
  DETAIL = 3,
  GROUP_DETAIL = 4,
  GROUP_CLUBS = 5,
  GROUP_CLUB_DETAIL = 6,
  GROUP_SCHEDULE = 7,
  GROUP_TABLE = 8,
  CATEGORY = 10,
  COMPETITION_SYSTEMS = 11,
  SCRIPTS = 12,
  ADD = 13,
  EDIT = 14,
  REFEREE = 15,
  TAKE_PERMISSION = 16,
}
